import { NotificationsButton } from 'app/components/notifications-button';
import { Row } from 'app/design/primitives/box';
import { createTheme as createDSTheme } from 'app/shopify';
import { Platform } from 'react-native';

const theme = createDSTheme();

export function HeaderRightNotifications() {
  return (
    <Row
      alignItems="center"
      gap="spacing.general.x4"
      style={{
        marginRight: Platform.OS === 'web' ? theme.spacing['spacing.general.x2'] : -theme.spacing['spacing.general.x2'],
      }}
    >
      <NotificationsButton />
    </Row>
  );
}
